import styled from 'styled-components'

import Tag from '~/shared/components/tags/Tag'

function CosplayGuide() {
  return (
    <Wrapper>
      <Title>코스플레이어 참가 안내</Title>
      <Tag $size={'md'} $variant={'gray'}>
        활동 가이드
      </Tag>
      <DescBox>
        <Desc>
          (1). 코스플레이어 활동을 위해서는 코스프레 입장권을 예매해 주셔야
          합니다.
          <br />
          (2). 일러스타 페스에서의 ‘코스프레’란, 특정 캐릭터의 복장이나 특성으로
          보일 수 있는 복장과 소품을 착용하고 있는 것으로 규정합니다.
          <br />
          (3). 자택/숙소에서 미리 코스프레를 하고 오시는 경우에도 코스플레이어
          입장권 구매를 부탁드립니다. 해당 비용은 코스프레 활동 관련 질서유지 및
          행사 운영에 사용됩니다.
          <br />
          (4). 입장권은 행사 종료 시까지 구매 가능하며, 당일 현장 발권을
          원하시는 경우 또한 일러스타 페스 공식 홈페이지에서 구매하신 후 입장해
          주시면 됩니다.
        </Desc>
        <Desc>
          <b>서클 참가와 코스플레이를 동시에 하시는 경우</b>
          <br />
          서클 부스 입장으로 입장해 주십시오. 서클 참가 확인을 거친 경우,
          코스프레 등록에 추가 비용은 따로 발생하지 않습니다.
        </Desc>
        <Desc>
          <b>코스플레이와 사진사 활동을 동시에 하는 경우</b>
          <br />
          코스프레 참가자는 별도의 사진사 등록을 거치지 않아도 기본적으로 사진사
          활동을 하실 수 있습니다.
        </Desc>
        <Desc>
          <b>코스프레 참가자 입장 방법 및 탈의실, 메이크업 테이블 이용 방법</b>
          <br />
          일러스타 페스에서는 코스프레 참가자 여러분의 편의를 위한 탈의실 및
          메이크업 테이블과 물품 보관소를 운영할 예정이며, 코스프레 참가자용
          편의 시설은 각 시설별 대기줄 순서대로 사용이 가능합니다,
        </Desc>
      </DescBox>
    </Wrapper>
  )
}

export default CosplayGuide

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  height: auto;
  padding: 36px 24px;

  background-color: white;
  border: 1px solid #c1c3c2;
  border-radius: 12px;
`
const Title = styled.h2`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: 500;
`

const DescBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const Desc = styled.p`
  font-size: 18px;
  line-height: 25px;
  white-space: pre-line;

  & > b {
    font-family: NanumSquareNeo-Bold, sans-serif;
    font-weight: 500;
  }
`
